<script>
	import Navbar from "./components/Navbar.svelte";
	// import Footer from "./components/Footer.svelte"

	const img = "/img/404.png";
	const home = location.protocol + "//" + location.host;
	const imgPath = home + img;
</script>

<Navbar />

<section>
	<div class="image-container">
		<a href={home}><img src={imgPath} alt="Whoops not found!" /></a>
	</div>
</section>

<!-- <Footer/> -->
<style>
	@media (max-width: 700px) {
		section {
			/* padding-left: 8%; */
			/* padding-right: 8%; */
			padding: 0%;
		}
		.image-container {
			margin: 5px !important;
		}
	}
	.image-container {
		margin: 55px;
		text-align: center;
	}
	img {
		max-width: 55%;
		max-height: 55%;
	}
</style>
